interface LegalModalProps {
  type: 'mentions' | 'confidentialite' | null;
  onClose: () => void;
}

const LegalModal = ({ type, onClose }: LegalModalProps) => {
  if (!type) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,42,94,0.55)' }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        {/* Header dégradé */}
        <div
          className="sticky top-0 flex items-center justify-between px-8 py-5 rounded-t-2xl z-10"
          style={{ background: 'linear-gradient(90deg, #004f9a 0%, #6ec5d8 100%)' }}
        >
          <h2 className="text-white font-bold text-xl">
            {type === 'mentions' ? 'Mentions légales' : 'Politique de confidentialité'}
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-lg" />
          </button>
        </div>

        <div className="px-8 py-7 text-[#1a3a60]">
          {type === 'mentions' && (
            <div className="flex flex-col gap-6 text-sm leading-relaxed">
              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">1. Éditeur du site</h3>
                <p className="text-[#4a6272]">
                  Le présent site est édité par la société <strong className="text-[#002a5e]">POLAR CLIM</strong>, entreprise individuelle immatriculée au Registre du Commerce et des Sociétés.
                </p>
                <ul className="mt-3 flex flex-col gap-1 text-[#4a6272]">
                  <li><strong className="text-[#002a5e]">Dénomination sociale :</strong> POLAR CLIM</li>
                  <li><strong className="text-[#002a5e]">Siège social :</strong> 5 Place de la Victoire, 06440 Blausasc</li>
                  <li><strong className="text-[#002a5e]">SIRET :</strong> 988 012 597 00015</li>
                  <li><strong className="text-[#002a5e]">Téléphone :</strong> 06 51 34 11 60</li>
                  <li><strong className="text-[#002a5e]">Courriel :</strong> Horn@gmx.fr</li>
                  <li><strong className="text-[#002a5e]">Zone d'intervention :</strong> Nice et ses environs (Alpes-Maritimes)</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">2. Activité professionnelle</h3>
                <p className="text-[#4a6272]">
                  POLAR CLIM exerce une activité d'installation, de maintenance et de dépannage de systèmes de climatisation, pompes à chaleur (air/air et air/eau), systèmes de ventilation mécanique contrôlée (VMC) et centrales de traitement d'air (CTA).
                </p>
                <p className="mt-2 text-[#4a6272]">
                  <strong className="text-[#002a5e]">Certification :</strong> L'entreprise est habilitée à manipuler les fluides frigorigènes — <strong>Catégorie I</strong>, conformément au Règlement (CE) n° 842/2006 et au Règlement (UE) n° 517/2014 relatifs aux gaz à effet de serre fluorés.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">3. Hébergement</h3>
                <p className="text-[#4a6272]">
                  Ce site est hébergé par la société <strong className="text-[#002a5e]">Readdy.ai</strong>.<br />
                  Site : <a href="https://readdy.ai" className="text-[#004f9a] underline" target="_blank" rel="nofollow noopener noreferrer">www.readdy.ai</a>
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">4. Propriété intellectuelle</h3>
                <p className="text-[#4a6272]">
                  L'ensemble des contenus présents sur ce site (textes, images, logos, visuels, structure) est la propriété exclusive de POLAR CLIM ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, diffusion ou utilisation sans autorisation préalable écrite est strictement interdite.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">5. Limitation de responsabilité</h3>
                <p className="text-[#4a6272]">
                  POLAR CLIM s'efforce de fournir des informations exactes et à jour sur ce site. Toutefois, des erreurs ou omissions peuvent survenir. L'entreprise ne saurait être tenue responsable de l'utilisation faite de ces informations ni des éventuels dommages directs ou indirects pouvant en résulter.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">6. Droit applicable</h3>
                <p className="text-[#4a6272]">
                  Le présent site et ses mentions légales sont soumis au droit français. En cas de litige, les tribunaux compétents du ressort de Nice (06) seront seuls compétents.
                </p>
              </div>
            </div>
          )}

          {type === 'confidentialite' && (
            <div className="flex flex-col gap-6 text-sm leading-relaxed">
              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">1. Responsable du traitement</h3>
                <p className="text-[#4a6272]">
                  Le responsable du traitement de vos données personnelles est :<br />
                  <strong className="text-[#002a5e]">POLAR CLIM</strong><br />
                  5 Place de la Victoire, 06440 Blausasc<br />
                  Contact : Horn@gmx.fr · 06 51 34 11 60
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">2. Données collectées</h3>
                <p className="text-[#4a6272]">Dans le cadre de l'utilisation du formulaire de contact et de demande de devis, nous collectons les données suivantes :</p>
                <ul className="mt-2 list-disc list-inside text-[#4a6272] flex flex-col gap-1">
                  <li>Nom et prénom</li>
                  <li>Adresse e-mail</li>
                  <li>Numéro de téléphone (facultatif)</li>
                  <li>Nature de la demande</li>
                  <li>Contenu du message</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">3. Finalités du traitement</h3>
                <p className="text-[#4a6272]">Vos données sont collectées exclusivement pour :</p>
                <ul className="mt-2 list-disc list-inside text-[#4a6272] flex flex-col gap-1">
                  <li>Répondre à vos demandes de renseignements et de devis</li>
                  <li>Planifier et assurer le suivi de vos interventions</li>
                  <li>Vous recontacter dans le cadre de la relation commerciale</li>
                </ul>
                <p className="mt-2 text-[#4a6272]">
                  <strong className="text-[#002a5e]">Base légale :</strong> intérêt légitime (répondre à vos demandes) et exécution d'un contrat ou de mesures précontractuelles.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">4. Durée de conservation</h3>
                <p className="text-[#4a6272]">
                  Vos données sont conservées pour une durée maximale de <strong className="text-[#002a5e]">3 ans</strong> à compter du dernier contact, sauf obligation légale contraire ou relation contractuelle active.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">5. Destinataires des données</h3>
                <p className="text-[#4a6272]">
                  Vos données personnelles sont strictement réservées à l'usage interne de POLAR CLIM. Elles ne sont jamais cédées, vendues ou louées à des tiers. Elles peuvent être transmises à nos prestataires techniques (hébergeur Readdy.ai) dans le strict cadre de l'exécution de leurs services.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">6. Vos droits (RGPD)</h3>
                <p className="text-[#4a6272]">Conformément au Règlement Général sur la Protection des Données (RGPD – UE 2016/679) et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
                <ul className="mt-2 list-disc list-inside text-[#4a6272] flex flex-col gap-1">
                  <li><strong className="text-[#002a5e]">Droit d'accès</strong> : obtenir une copie de vos données</li>
                  <li><strong className="text-[#002a5e]">Droit de rectification</strong> : corriger des données inexactes</li>
                  <li><strong className="text-[#002a5e]">Droit à l'effacement</strong> : demander la suppression de vos données</li>
                  <li><strong className="text-[#002a5e]">Droit d'opposition</strong> : s'opposer à un traitement</li>
                  <li><strong className="text-[#002a5e]">Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
                </ul>
                <p className="mt-3 text-[#4a6272]">
                  Pour exercer ces droits, contactez-nous à : <a href="mailto:Horn@gmx.fr" className="text-[#004f9a] underline">Horn@gmx.fr</a><br />
                  En cas de réclamation, vous pouvez saisir la <strong className="text-[#002a5e]">CNIL</strong> : <a href="https://www.cnil.fr" className="text-[#004f9a] underline" target="_blank" rel="nofollow noopener noreferrer">www.cnil.fr</a>
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">7. Cookies</h3>
                <p className="text-[#4a6272]">
                  Ce site n'utilise pas de cookies de traçage ni de cookies publicitaires. Seuls des cookies techniques strictement nécessaires au bon fonctionnement du site peuvent être utilisés. Aucun consentement n'est requis pour ces cookies essentiels.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-[#002a5e] text-base mb-2">8. Sécurité</h3>
                <p className="text-[#4a6272]">
                  POLAR CLIM met en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, perte, destruction ou divulgation.
                </p>
              </div>

              <p className="text-[#4a6272] text-xs border-t border-[#cce8f4] pt-4">
                Dernière mise à jour : mars 2026
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
